<template>
  <div class="tabulka" :class="TableWidth">
    <div class="tabulka__top">
      <div class="tabulka__top__nadpis">Purchased data</div>
    </div>

    <div class="tabulka__body">
      <table>
        <thead>
          <td>
            <span>Round</span>
            <SortButton
              row="turn"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td>
            <span>Type</span>
            <SortButton
              row="type"
              type="a"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td class="right">
            <SortButton
              row="price"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
              floatRight="yes"
            />
            <span>Spent</span>
          </td>
          <td>
            <span></span>
          </td>
        </thead>
        <tr v-for="data in sortedData" :key="data.id">
          <td class="important">
            <span>{{ data.turn }}.</span>
          </td>
          <td>{{ $t(`texts.data.${data.type}`) }}</td>
          <td class="right">
            {{ data.price | numbersThousands | inCurrency }}
          </td>
          <td>
            <button class="button" @click="downloadPurchasedData(data.id)">
              Download data
            </button>
          </td>
        </tr>

        <tr v-if="!this.sourceData.length">
          <td>{{ $t(`texts.data.no-data-purchased`) }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import SortButton from "@/components/game/table/SortButton.vue";
import sortingLogicMixin from "@/components/game/table/sortingLogicMixin.js"; // obsahuje logiku k sortovani
import { mapGetters, mapActions } from "vuex";

export default {
  name: "PurchasedData",
  mixins: [sortingLogicMixin],
  components: {
    SortButton,
  },
  props: {
    TableWidth: String,
  },
  data: function () {
    return {
      currentSortRow: "turn",
      currentSortDirection: -1,
    };
  },
  computed: {
    ...mapGetters({
      sourceData: "myTeamPurchasedData",
    }),
  },
  methods: {
    ...mapActions({ downloadPurchasedData: "downloadPurchasedData" }),
  },
};
</script>

